import { render, staticRenderFns } from "./FileDocumentIcon.vue?vue&type=template&id=0eb9565d&scoped=true&"
import script from "./FileDocumentIcon.vue?vue&type=script&lang=js&"
export * from "./FileDocumentIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb9565d",
  null
  
)

export default component.exports